
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/[city]",
      function () {
        return require("private-next-pages/magazine/[city].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/[city]"])
      });
    }
  